// reference: https://qiita.com/azukiazusa/items/a50b1ffe05d9937a4db0

import Vue from "vue";
import Vuex from "vuex";
import createLogger from "../common/logger";
import { Store } from "vuex";
import { initializeStores } from "../utils/store-accessor";
const initializer = (store: Store<any>) => initializeStores(store);
export const plugins = [initializer];
export * from "../utils/store-accessor";
import { LoginUser } from "./modules/loginUser";
import { Companies } from "../store/modules/companies";
import { Departments } from "../store/modules/departments";
import { Employees } from "../store/modules/employees";
import { Histories } from "../store/modules/histories";
import { OperationLogs } from "../store/modules/operationLogs";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    LoginUser,
    Companies,
    Departments,
    Employees,
    Histories,
    OperationLogs,
  },
  plugins:
    process.env.NODE_ENV !== "production"
      ? [...plugins, createLogger()]
      : plugins,
});
